/* eslint-disable react/no-array-index-key */
import { numberFormat } from 'constants/formats';
import { FC } from 'react';
import NumberFormat from 'react-number-format';

import { CoOwner } from 'types';
import { formatNumberDecimals } from 'utils/formats';

type Props = {
  index: number;
  coOwner: CoOwner;
  // eslint-disable-next-line no-unused-vars
  handleRemoveCoOwner?: (index: number) => void;
};

const ShareEncumbranceViewCoOwnersTableRow: FC<Props> = ({
  index,
  coOwner,
  handleRemoveCoOwner,
}) => (
  <tr key={`co-owner-row-${index}`}>
    <td className="text-left text-primary d-block text-ellipsis w-150px">
      {coOwner?.name}
    </td>

    <td className="text-left">{coOwner?.cif}</td>

    <td className="text-left d-block text-ellipsis w-150px">
      {coOwner?.email}
    </td>

    <td className="text-right">
      <NumberFormat
        value={formatNumberDecimals(coOwner?.percent)}
        displayType="text"
        suffix="%"
        decimalSeparator={numberFormat.decimalSeparator}
      />
    </td>

    <td className="text-justify">{coOwner?.comment || '-'}</td>

    <td className="text-center">
      {handleRemoveCoOwner && (
        <button
          type="button"
          className="text-soft btn btn-icon pt-0 pb-0"
          onClick={() => handleRemoveCoOwner(index)}
        >
          <em className="icon ni ni-trash" />
        </button>
      )}
    </td>
  </tr>
);

export default ShareEncumbranceViewCoOwnersTableRow;
